import { yupResolver } from "@hookform/resolvers/yup";
import { useDisclosure } from "@nextui-org/react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { patchFetcher, postFetcher, deleteFetcher } from "../../services/api";
import { isResponseErrorObject } from "../../services/helpers";
import { useState } from "react";
import { format } from "date-fns";
import { periodValidation } from "../../services/validation/period.validation";

export default function usePeriod({ mutate }) {
  const [editId, setEditId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const { isOpen: isOpenModalForm, onOpen: onOpenModalForm, onOpenChange: onOpenChangeModalForm, onClose: onCloseModalForm } = useDisclosure();
  const { isOpen: isOpenModalAlert, onOpenChange: onOpenChangeModalAlert } = useDisclosure();
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { isSubmitting, dirtyFields },
  } = useForm({ resolver: yupResolver(periodValidation) });

  function onClickEdit(item) {
    setEditId(item.id);
    setIsEdit(true);
    reset({
      name: item.name,
      startPeriodDate: format(item.startPeriodDate, "yyyy-MM-dd"),
      endPeriodDate: format(item.endPeriodDate, "yyyy-MM-dd"),
      finalizationDeadline: format(item.finalizationDeadline, "yyyy-MM-dd"),
      isActive: item.isActive,
    });
    onOpenChangeModalForm();
  }

  function onClickDelete(id) {
    setEditId(id);
    onOpenChangeModalAlert();
  }

  async function onSubmitDelete() {
    try {
      await deleteFetcher(`/api/period`, editId);
      mutate();
      toast.success("Periode berhasil dihapus!");
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
    }
  }

  function onCloseForm() {
    setEditId(null);
    setIsEdit(false);
    reset({
      name: "",
      startPeriodDate: "",
      endPeriodDate: "",
      finalizationDeadline: "",
      isActive: false,
    });
    onCloseModalForm();
  }

  async function onSubmitForm(data) {
    try {
      if (isEdit) {
        const formattedData = {
          ...data,
          startPeriodDate: data.startPeriodDate ? format(new Date(data.startPeriodDate), "yyyy-MM-dd") : "",
          endPeriodDate: data.endPeriodDate ? format(new Date(data.endPeriodDate), "yyyy-MM-dd") : "",
          finalizationDeadline: data.finalizationDeadline ? format(new Date(data.finalizationDeadline), "yyyy-MM-dd") : "",
        };

        console.log("Payload dikirim:", formattedData);

        await patchFetcher("/api/period", editId, formattedData);
        mutate();
        toast.success(`Periode berhasil diperbarui!`);
      } else {
        const formattedData = {
          ...data,
          startPeriodDate: data.startPeriodDate ? format(new Date(data.startPeriodDate), "yyyy-MM-dd") : "",
          endPeriodDate: data.endPeriodDate ? format(new Date(data.endPeriodDate), "yyyy-MM-dd") : "",
          finalizationDeadline: data.finalizationDeadline ? format(new Date(data.finalizationDeadline), "yyyy-MM-dd") : "",
        };

        await postFetcher("/api/period/create", formattedData);
        mutate();
        toast.success("Periode berhasil ditambah!");
      }
      onCloseForm();
    } catch (error) {
      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
    }
  }
  return {
    modalForm: {
      isOpenModalForm,
      onOpenModalForm,
      onOpenChangeModalForm,
    },
    modalAlert: {
      isOpenModalAlert,
      onOpenChangeModalAlert,
    },
    hookForm: {
      register,
      control,
      handleSubmit,
      reset,
      formState: { isSubmitting, dirtyFields, isEdit },
    },
    onClickEdit,
    onCloseForm,
    onSubmitForm,
    onClickDelete,
    onSubmitDelete,
  };
}
